import { createGlobalStyle } from "styled-components";

// The @font-face rules live in ./fonts/fonts.css, not here. styled-components
// re-parses this sheet whenever it adds rules for a newly mounted component,
// which would drop and reload the fonts and make the whole page reflow. See the
// comment in that file.

export const GlobalStyle = createGlobalStyle`
:root {
  --atira-main: #803588;
  --atira-sub: #ebebeb;
  --atira-light-main: #934599;
  --atira-font-size-heading-xl: clamp(2rem, calc(4vw + 1rem), 3.5rem);
  --atira-font-size-heading: clamp(1.6rem, calc(3vw + 0.5rem), 2.5rem);
  --atira-font-size-sub-heading: clamp(1.3rem, calc(1.25vw + 0.5rem), 2rem);
  --atira-font-size-body: clamp(1rem, calc(1vw + 0.25rem), 1.125rem);
  --atira-font-size-small: clamp(0.875rem, calc(0.75vw + 0.25rem), 1rem);
  --atira-font-size-note: clamp(0.75rem, calc(0.5vw + 0.25rem), 0.875rem)
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body,
#root {
  width: 100%;
  font-family: 'Zain', 'Roboto', sans-serif;
  /* 100vh overshoots the visible area under the iOS Safari toolbar; dvh tracks
     it. vh stays as the fallback for browsers without dvh. */
  height: 100vh;
  height: 100dvh;
}

/*  */

.ant-dropdown-menu-submenu-title {
  padding-inline-start: 0 !important;
}

.ant-dropdown-menu .ant-dropdown-menu-item.logout-button:hover,
.ant-dropdown-menu .ant-dropdown-menu-item.user-email:hover,
.ant-dropdown-menu .ant-dropdown-menu-item.hr:hover {
  cursor: default;
  background-color: transparent !important;
}

.ant-notification-notice-message, .ant-notification-notice-description {
  font-family: "Zain", "Roboto", sans-serif ;
}

/* The dual-panel RTL range picker is 48rem wide and overflows viewports
   narrower than that. Only widen it where there's room; below the tablet
   breakpoint antd's default single-panel sizing takes over. */
@media (min-width: 768px) {
  html[dir=rtl] .ant-picker-date-range-wrapper .ant-picker-panel-container  {
    width: 48rem;
  }

  html[dir=rtl] .ant-picker-date-range-wrapper  .ant-picker-panel,
  html[dir=rtl] .ant-picker-date-range-wrapper  .ant-picker-date-panel  {
    width: 24rem;
  }
}

.header-search-dropdown   {
  width: fit-content !important;
}

`;
